/** @jsxRuntime classic */
/** @jsx jsx */

import { ReactNode } from 'react';
import { css, jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';
import { MEDIA_MIN_WIDTH } from '../../constants';

export interface VisibilityProps {
  children: ReactNode;
  hideOnMobile?: boolean;
  hideOnTablet?: boolean;
  hideOnDesktop?: boolean;
}

const Styles = labelStyles('Visibility', {
  root: (hideOnMobile = false, hideOnTablet = false, hideOnDesktop = false) => {
    return css({
      display: hideOnMobile ? 'none' : 'block',

      [MEDIA_MIN_WIDTH.small]: {
        display: hideOnTablet ? 'none' : 'block',
      },

      [MEDIA_MIN_WIDTH.large]: {
        display: hideOnDesktop ? 'none' : 'block',
      },
    });
  },
});

export function Visibility(props: VisibilityProps) {
  return (
    <div
      css={Styles.root(
        props.hideOnMobile,
        props.hideOnTablet,
        props.hideOnDesktop,
      )}
    >
      {props.children}
    </div>
  );
}
